import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import postscribe from 'postscribe';



@Component({
  selector: 'podcast-modal',
  templateUrl: './podcast-modal.component.html',
  styleUrls: []
})
export class PodcastModalComponent implements OnInit {
    @Input() podcastUrl: string;
    @Input() Transcript: string;
    script: any;
    constructor(public activeModal: NgbActiveModal) {
    }

    ngOnInit(): void {
        this.script = "<script src='"+this.podcastUrl +"' type='text/javascript' charset='utf-8'> </script>";
        postscribe('#transcript', this.script);
  }
}
